var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",style:(_vm.styles)},[_c('div',{class:{
      'border-container d-flex align-center justify-center': true,
      gold: _vm.goldMember,
    }},[(_vm.profilePhotoUrl)?_c('img',{attrs:{"src":_vm.profilePhotoUrl}}):_c('v-icon',{staticClass:"person-icon",attrs:{"color":"textColor","size":_vm.iconSize}},[_vm._v("\n      person\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }